import { render } from "./AttendanceView.vue?vue&type=template&id=316eed7a"
import script from "./AttendanceView.vue?vue&type=script&lang=js"
export * from "./AttendanceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__